import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import outback from "../../../../assets/info/outback-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/subaru-outback/subaru-outback-fig-1.jpg";
import styled from "styled-components";
import { popularVehicle } from "../../../../vars/popularVehicles";

const SubaruOutback = () => {
  useSmallNav("Subaru Outback");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Subaru Outback"} bolder />
        <InfoHero image={outback} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Have you recently had a quote for rear self levelling Subaru Outback Suspension?"
              }
            />
            <p>
              If you have recently had a quote from Subaru, you will know just
              how expensive replacement self levelling rear struts are! Pedders
              Suspension have the cost effective solution to your problems. We
              offer a replacement spring and damper kit for the rear of your
              Outback that will eliminate the troublesome self levelling
              arrangement. This is achieved by installing a conventional style
              rear shock and spring designed for this application.
            </p>
            <p>
              The kit is a direct bolt in replacement. No modifications to the
              vehicle are required. No extra parts are required. When fitting
              you will need to re-use the original top mount arrangement. Spring
              compressors will be required to complete this task.
            </p>
            <p>
              Will my vehicle really be returned to its original Ride height?
              Yes, definitely! There are numerous examples of Outbacks having
              had the Self-Levellers replaced with conventional dampers which
              then sit to low. This is because the original spring is not
              designed to support the full weight of the car on its own as it is
              normally assisted by the self levelling damper.
            </p>
            <p>
              Pedders Suspension overcome this be supplying a matched set of
              dampers and springs specifically for this purpose. You can buy
              with full confidence that the vehicle will be the correct height
              and your troublesome and expensive self levelling dampers
              consigned to history.
            </p>
            <p>
              If you want that Sporty Look and would like to lower your Outback,
              we also offer a lowered spring. We recommend lowering the rear of
              your vehicle in conjunction with lowering the front suspension to
              match.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Subaru Outback Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Subaru Outback Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Subaru")
              .models.find((e) => e.display === "Outback")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <div>
                <StyledImgParts src={part1} alt="Outback Suspension Kits" />
              </div>
            </Gray>
          </div>
        </InfoGrid>
      </Container>
    </section>
  );
};

export default SubaruOutback;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
